import ResponsiveText from 'components/Table/responsive/Text';
import React from 'react';

const Position = ({ globalState, item }) => {
    const category = globalState.config.selectedCategory;
    const subcategory = globalState.config.selectedSubcategory;

    const targetCategoryId = subcategory.value === -2 ? category.value : subcategory.value;

    const cat = targetCategoryId ? item.categories.find(({ category }) => category === targetCategoryId) : null;

    return <ResponsiveText text={cat ? `${cat.position}` : ''} />;
};

export default Position;
